import { useState } from "react";
import { Button } from "../../../../../../../stories/Button/Button";
import TicketDetails from "./TicketDetails";
import FollowUpStatus from "./FollowUpStatus";
import Legends from "../Legends";
import { CustomModal } from "../../../../../../../utils/UtilFunctions";
import {
  ViewAssetStyles,
  ViewItemsModalStyles,
} from "../../../../../../../styles/CustomModalStyles";
import JunctionLevelTicketing from "../JunctionIndex";
import { StateTypes } from "../../../Maps";
import { TableType } from "../../../../../customer/companies/queries/types";
import { RaisedTicketDetailsProps } from "./RaisedTicketDetails";
import TicketItemDetails from "./TicketItemDetails";
import FollowUpItemStatus from "./FollowUpItemStatus";

export enum AssetDetailsPageFor {
  MAPS = "MAPS",
  REPORTS = "REPORTS",
  DASHBOARD = "DASHBOARD",
}
const AssetDetails = ({
  setModalFlag,
  assetType,
  pageFor,
  itemsView,
}: RaisedTicketDetailsProps) => {
  const [assetDetails, setAssetdetails] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  return (
    <>
      <div className="junc-asset-details">
        <div className="junc-asset-details__block">
          <div className="junc-asset-details__block--left">
            {itemsView ? (
              <TicketItemDetails
                pageFor={pageFor}
                assetType={TableType.ASSET}
              />
            ) : (
              <TicketDetails pageFor={pageFor} assetType={assetType} />
            )}
          </div>
          <div className="junc-asset-details__block--right">
            {itemsView ? <FollowUpItemStatus /> : <FollowUpStatus />}
          </div>
        </div>
        <div className="junc-asset-details__button">
          <div>
            {pageFor !== AssetDetailsPageFor.REPORTS ? (
              itemsView ? null : (
                <Button
                  mode="raise"
                  onClick={() =>
                    setAssetdetails({
                      flag: true,
                      itemId: 0,
                      tableLevel: TableType.COMPANY,
                    })
                  }
                >
                  Ticket
                </Button>
              )
            ) : null}
            <Button
              mode="cancel"
              onClick={() =>
                setModalFlag({
                  flag: false,
                  itemId: 0,
                  tableLevel: TableType.COMPANY,
                })
              }
            />
          </div>
          <Legends />
        </div>
      </div>
      <CustomModal
        style={itemsView ? ViewItemsModalStyles : ViewAssetStyles}
        isOpen={assetDetails.flag}
        onRequestClose={() =>
          setAssetdetails({
            flag: false,
            itemId: 0,
            tableLevel: TableType.CUSTOMER,
          })
        }
        contentComponent={
          <JunctionLevelTicketing
            setModalFlag={setAssetdetails}
            assetType={assetType}
            showRaiseTicket
            isItemsView={itemsView}
          />
        }
      />
    </>
  );
};

export default AssetDetails;
